/* eslint-disable import/order */
/* eslint-disable camelcase */
import { sentenceCase } from 'change-case';
import { useState, useCallback, useEffect } from 'react';
// @mui
import {
  Card,
  Table,
  Avatar,
  Button,
  Container,
  Typography,
  Box,
  CircularProgress,
  Chip,
  Select,
  InputLabel,
  FormControl,
  MenuItem,
  TablePagination,
  Link,
  IconButton
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
// routes
import axios, { getErrorMessage } from 'utils/axios';
import useIsMountedRef from 'hooks/useIsMountedRef';
import CRUD from 'utils/Crud';
import { fDate, fDateTime } from 'utils/formatTime';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { PATH_DASHBOARD } from '../../routes/paths';
// hooks
import useSettings from '../../hooks/useSettings';

// components
import Page from '../../components/Page';
import Iconify from '../../components/Iconify';
import HeaderBreadcrumbs from '../../components/HeaderBreadcrumbs';
// sections
import Swal from 'sweetalert2'
import AppColors from "utils/AppColors";
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { LoadingButton } from '@mui/lab';
import SearchQueryDailog from 'sections/@dashboard/SearchQueryDailog';
import { useSnackbar } from 'notistack';
import EditUserModal from 'sections/@dashboard/user/EditUserModal';
import { Link as RouterLink } from 'react-router-dom';
import ProfileDialog from 'sections/@dashboard/user/ProfileDialog';
import Label from 'components/Label';
import { fNumber } from 'utils/formatNumber';
import GiftcardOrderDialog from 'sections/@dashboard/order/GiftcardOrderDialog';
import CustomGridToolbar from 'components/CustomGridToolbar';
import useAuth from 'hooks/useAuth';
// ----------------------------------------------------------------------



export default function GiftcardOrders() {
  const theme = useTheme();
  const { themeStretch } = useSettings();
  const isMountedRef = useIsMountedRef();
  const [sort, setSort] = useState({field:'id', order:'desc',start_date:'',end_date:'',status:''});
  const [data, setData] = useState({data:[],current_page:1,total_pages:null,total_size:0,page_size:0});
  const [state,setState] = useState({loading:false,loadComplete:false,error:null});
  const [query,setQuery] = useState({page_size:2,page:0});
  const [dailog,setDailog] = useState({open:false,query:"",});
  const [profileDialog,setProfileDialog] = useState({open:false,user:"",});
  const [search,setSearch] = useState({open:false,query:"", list:[]});
  const [orderDialog,setOrderDialog] = useState({open:false,user:"",});
  const { enqueueSnackbar } = useSnackbar();
  const { user } = useAuth();


  useEffect(() => {
    getInitData();
  }, []);

  // const updateData = (k, v) => setData((prev) => ({ ...prev, [k]: v }));

  return (
    <Page title="Giftcard order">
      <Container maxWidth={themeStretch ? false : 'lg'}>
        <HeaderBreadcrumbs
          heading="Giftcard orders"
          links={[
            { name: 'Dashboard', href: PATH_DASHBOARD.root },
            { name: 'Order', href: PATH_DASHBOARD.order.list },
            { name: 'Giftcard' },
          ]}
          action={
            <Button
              variant="contained"
              component={Button}
              onClick={()=>{
                setDailog({open:true, isEdit: false});
              }}
              startIcon={<Iconify icon={'cil:search'} />}
            >
             Find request
            </Button>
          }
        />

        {!state.loading && state.error !=null && (
          <Card>
            <Box padding={10} display={"flex"} justifyContent={"center"}>
            <p>Error {state.error} </p>
            </Box>
          </Card>
        )}

        <Card>
          {search.open && 
          <Box sx={{display:"flex", alignContent:"right", justifyContent:"space-between", width:"100%", padding:2}}>
            <p>Showing results for: {search.query}</p>
            <LoadingButton sx={{mr:2}}
              startIcon={<Iconify icon={'carbon:close-filled'} />}
              loading={state.loading} 
              onClick={()=> setSearch({...search, open:false})}
               variant='outlined' color="error">
                Close search
            </LoadingButton>
          </Box>}
          {!search.open && 
          <Box sx={{display:"flex", alignContent:"right", justifyContent:"end", width:"100%", padding:2}}>
             <FormControl sx={{ml:2,width:180}}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker 
                  value={sort.start_date}
                  label="From date"
                  onChange={(newValue) => setSort({...sort,start_date:newValue})}
                  renderInput={(params) => <TextField {...params} size="small" fullWidth />}
                />
              </LocalizationProvider>
            </FormControl>
            <FormControl sx={{ml:2,width:180}}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker 
                  value={sort.end_date}
                  label="To date"
                  onChange={(newValue) => setSort({...sort,end_date:newValue})}
                  renderInput={(params) => <TextField {...params} size="small" fullWidth />}
                />
              </LocalizationProvider>
            </FormControl>
            <FormControl sx={{width:180,ml:2}}>
              <InputLabel id="demo-simple-select-label">Status</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                label="Status"
                value={sort.status}
                onChange={(e)=> setSort({...sort,status:e.target.value})}
                >
                {[
                  {v:'',n:"All status"},
                  {v:'pending',n:"Pending"},
                  {v:'abandoned',n:"abandoned"},
                  {v:'completed',n:"Completed"},
                  ].map((opt,i) => (
                <MenuItem key={i} value={opt.v}>{opt.n}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <FormControl sx={{ml:2,width:180}}>
              <InputLabel id="demo-simple-select-label2">Created at</InputLabel>
              <Select
                labelId="demo-simple-select-label2"
                label="Created at"
                value={sort.order}
                onChange={(e)=> setSort({...sort,order:e.target.value})}
              >
                {[
                  {v:'asc',n:"Ascending"},
                  {v:'desc',n:"Descending"},
                  ].map((opt,i) => (
                <MenuItem key={i} value={opt.v}>{opt.n}</MenuItem>
                ))}
              </Select>
            </FormControl>
            <LoadingButton loading={state.loading} onClick={()=> getInitData()}
              sx={{ml:2}} variant='outlined' color="secondary">
                Apply changes
            </LoadingButton> 
            
          </Box>}

          <Box sx={{ height: 700, width: '100%' }}>
            <DataGrid
              rows={search.open ? search.list : data.data}
              columns={[
                {
                  field: 'name',
                  headerName: 'Name',
                  width: 220,
                  editable: false,
                  renderCell: (params) => (
                    < >
                      <IconButton color="primary" onClick={()=> setProfileDialog({open:true,user:params.row})}>
                        <Iconify icon={'ph:user-thin'} size="small" sx={{width:25,height:25}} />
                      </IconButton>
                      <Typography variant="subtitle2" sx={{cursor:"pointer"}} noWrap>
                        {params.row.first_name} {params.row.last_name}
                      </Typography>
                    </>
                  ),
                  valueGetter: (params) => `${params.row.first_name} ${params.row.last_name}`
                },
                {
                  field: 'order_id',
                  headerName: 'Order I.D',
                  width: 180,
                  editable: false,
                  valueGetter: (params) => params.value,
                  renderCell: (params) => (
                    <p>
                      <IconButton color="primary" onClick={()=> setOrderDialog({open:true,order:params.row})}>
                        <Iconify icon={'ion:open-outline'} size="small" sx={{width:25,height:25}} />
                      </IconButton>
                      #{params.value}
                    </p>
                  ),
                },
                
                // {
                //   field: 'contact_name',
                //   headerName: 'Contact',
                //   width: 180,
                //   editable: false,
                // },
                {
                  field: 'category',
                  headerName: 'Category',
                  width: 180,
                  editable: false,
                  renderCell: (params) => (
                    <p> {params.value}-{params.row.type_name}</p>
                  ),
                },
                // {
                //   field: 'sub_category',
                //   headerName: 'Sub-category',
                //   width: 200,
                //   editable: false,
                // },
                {
                  field: 'status',
                  headerName: 'Status',
                  width: 180,
                  editable: false,
                  renderCell: (params) => {
                    let color = (params.value === 'abandoned' && 'error') || 'secondary';
                    if(params.value === "completed"){
                      color = 'success';
                    } else if(params.value === "pending"){
                      color = 'warning';
                    } else {
                      color = 'error';
                    }
                    return <Label
                              variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                              color={color} >
                          {sentenceCase(params.value)}
                        </Label>
                  },
                  valueGetter: (params) => params.row.status
                },
                {
                  field: 'amount',
                  headerName: 'Amount',
                  width: 180,
                  editable: false,
                  valueGetter: (params) => `${params.row.currency}${fNumber(params.value * params.row.number_of_cards)}`
                },
                {
                  field: 'settlement_amount',
                  headerName: 'Settlement Amount',
                  width: 180,
                  editable: false,
                  valueGetter: (params) => `NGN${fNumber(params.value)}`
                },
                {
                  field: 'total_trade_amount',
                  headerName: 'Trade Amount',
                  width: 180,
                  editable: false,
                  valueGetter: (params) => `NGN${fNumber(params.value)}`
                },
                {
                  field: 'stake',
                  headerName: 'Stake',
                  width: 180,
                  editable: false,
                  valueGetter: (params) => `NGN${fNumber(params.value)}`,
                  renderCell: (params) => {
                    const color = parseFloat(params.row.net_profit) > 1  ? 'secondary' : 'error';
                    return <Label 
                            variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}  
                            color={color} >
                          {params.value}
                        </Label>
                  },
                },
                {
                  field: 'final_settlement_amount',
                  headerName: 'Final Settlment Amount',
                  width: 180,
                  editable: false,
                  valueGetter: (params) => `NGN${fNumber(params.value)}`
                },
                
                {
                  field: 'staff_name',
                  headerName: 'Completed by',
                  width: 180,
                  editable: false,
                },
                {
                  field: 'vendor_rate',
                  headerName: 'Vendor rate (per $)',
                  width: 180,
                  editable: false,
                  valueGetter: (params) => `NGN${fNumber(params.value)}`
                },
                {
                  field: 'rate',
                  headerName: 'Rate (per $)',
                  width: 180,
                  editable: false,
                  valueGetter: (params) => `NGN${fNumber(params.value)}`
                },
                {
                  field: 'final_amount',
                  headerName: 'Final amount (USD)',
                  width: 180,
                  editable: false,
                  valueGetter: (params) => `${params.row.currency}${fNumber(params.value)}`
                },
                {
                  field: 'number_of_cards',
                  headerName: 'Number of cards',
                  width: 180,
                  editable: false,
                },
                // {
                //   field: 'settlement_charges',
                //   headerName: 'Settlement charges',
                //   width: 180, 50 + 20, 
                //   editable: false, | 450,000 | Safegoal. Daniel
                //   valueGetter: (params) => `NGN${fNumber(params.value)}`
                // },
                user.is_admin ?
                {
                  field: 'gross_amount',
                  headerName: 'Gross amount(NGN)',
                  width: 180,
                  editable: false,
                  valueGetter: (params) => `NGN${fNumber(params.value)}`
                } : {},
                user.is_admin ?
                {
                  field: 'gross_profit',
                  headerName: 'Gross profit(NGN)',
                  width: 180,
                  editable: false,
                  valueGetter: (params) => `NGN${fNumber(params.value)}`
                } : {},
                user.is_admin ?
                {
                  field: 'net_profit',
                  headerName: 'Net amount(NGN)',
                  width: 180,
                  editable: false,
                  valueGetter: (params) => `NGN${fNumber(params.value)}`
                } : {},
                {
                  field: 'updated_at',
                  headerName: 'Updated at',
                  width: 180,
                  editable: false,
                  valueGetter: (params) => fDate(params.value),
                },
                {
                  field: 'created_at',
                  headerName: 'Created at',
                  width: 180,
                  editable: false,
                  valueGetter: (params) => fDate(params.value),
                },
              
              ]}
              
              loading={state.loading}
              checkboxSelection
              disableRowSelectionOnClick
              components={{ Toolbar: CustomGridToolbar }}
              disableSelectionOnClick

              // pagination 
              paginationMode="server"
              rowCount={data.total_size}
              page={data.current_page - 1}
              rowsPerPage={data.data.length}
              onPageChange={(newPage)=> {
                setQuery({...query, page:newPage + 1});
                getInitData(newPage + 1);
              }}
              pageSize={data.page_size}
              onPageSizeChange={(newPage) => setQuery({...query, page_size:newPage})}
              rowsPerPageOptions={[]}
              
            />
          </Box>

        </Card>
      </Container>


      {orderDialog.open &&  <GiftcardOrderDialog
        item={orderDialog.order}
        handleClose={(order)=>{
          setOrderDialog({open:false});
          if(order){
            // const list = data.data;
            // Safely update the specific order in the list
            setData(prev => ({
              ...prev,
              data: prev.data.map(item =>
                item.order_id === order.order_id ? { ...item, ...order } : item
              )
            }));
          }
        }}
         />}


      {profileDialog.open &&  <ProfileDialog
        user={profileDialog.user}
        handleClose={()=>{
          setProfileDialog({open:false});
        }}
        refresh
         />}


      {dailog.open &&  <SearchQueryDailog
        open={dailog.open}
        hint='Search database for matching records'
        label="Enter request I.D"
        handleClose={()=>{
          setDailog({open:false});
        }}
        onSubmit={(val)=>{
          setDailog({open:false});
          searchUser(val);
        }}
        />}

    </Page>
  );

  async function getInitData(page = null) {
    
    const sdate = sort.start_date ?  new Date(sort.start_date).toDateString() : '';
    const edate = sort.end_date ?  new Date(sort.end_date).toDateString() : '';

    setState({...state,loading:true,loadComplete:false,error:null});

    try {

      let str = `?&sort_order=${sort.order}&status=${sort.status}`;
        str+= `&page=${page || query.page}&&page_size=${query.page_size}`;
        str+= `&start_date=${sdate}&end_date=${edate}`;

      const response = await axios.get(CRUD.order.giftcardList+str);

      if (isMountedRef.current) {
        setData(response.data);
      }
      setState({...state,loading:false,loadComplete:true,error:null})
    } catch (error) {
      // console.error(error);
      setState({...state,loading:false,loadComplete:false,error: getErrorMessage(error)})
    }
  };


  async function searchUser(query) {
    
    setState({...state,loading:true});
    setSearch({open:true,query,list:[]});

    try {
      const str = `?query=${query}`;
      const response = await axios.get(CRUD.order.giftcardSearch+str);

      if (isMountedRef.current) {
        setSearch({open:true,query, list:response.data});
        setState({...state,loading:false});
      }
    } catch (error) {
      // console.error(error);
      setState({...state,loading:false});
      enqueueSnackbar(getErrorMessage(error));
    }
  };

}
